import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import Field from "../../components/ui/Field";
import Input from "../../components/ui/Input";
import { loginRequest } from "../../services/api/auth.api";
import { setAdminEmail, setTokens } from "../../services/storage/token.storage";

const LoginPage: React.FC = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [globalError, setGlobalError] = useState<string | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setGlobalError(null);
        setIsSubmitting(true);

        try {
            const response = await loginRequest({
                email,
                password,
            });

            setTokens(response.access_token, response.refresh_token);
            setAdminEmail(email);
            navigate("/");
        } catch (error) {
            const message =
                error instanceof Error ? error.message : "Не удалось войти в систему";
            setGlobalError(message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="auth-layout">
            <div className="auth-panel">
                <div className="auth-panel-head">
                    <div className="auth-logo">S</div>
                    <p className="auth-kicker">ShowMust Admin</p>
                    <h1 className="auth-title">Вход в панель управления</h1>
                    <p className="auth-description">
                        Используйте логин и пароль администратора для доступа к разделам
                        пользователей, контента, событий, заказов и настроек.
                    </p>
                </div>

                <form className="auth-form" onSubmit={handleSubmit}>
                    <Field label="E-mail" htmlFor="email">
                        <Input
                            id="email"
                            type="email"
                            placeholder="admin@showmust.de"
                            autoComplete="email"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                        />
                    </Field>

                    <Field label="Пароль" htmlFor="password">
                        <Input
                            id="password"
                            type="password"
                            placeholder="Введите пароль"
                            autoComplete="current-password"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                        />
                    </Field>

                    {globalError ? <div className="form-global-error">{globalError}</div> : null}

                    <Button type="submit" fullWidth disabled={isSubmitting}>
                        {isSubmitting ? "Входим..." : "Войти"}
                    </Button>
                </form>

                <div className="auth-links">
                    <Link to="/forgot-password" className="text-link">
                        Восстановить пароль
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
